import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ICatProveedores from '../../../Interfaces/Catalogos/ICatProveedores'
const CatProveedores: ICatProveedores[] = []
const initialState = { CatProveedores }

export const CatProveedoresSlice = createSlice({
  name: 'CatProveedores',
  initialState: initialState,
  reducers: {
    resetCatProveedores : (state, action: PayloadAction<string>) => {
      state.CatProveedores =  []
    },  
    populateCatProveedores : (state, action: PayloadAction<ICatProveedores[]>) => {
        action.payload.forEach(element => {
            const index = state.CatProveedores.findIndex(object => object.id === element.id)
            if (index<0) state.CatProveedores.push(element)
        })
    },
    updateCatProveedores : (state, action: PayloadAction<ICatProveedores>) => {
      const i = state.CatProveedores.findIndex(_element => _element.id === action.payload.id);
      if (i > -1) state.CatProveedores[i] = action.payload;
      else state.CatProveedores.push(action.payload);
    },
    deleteCatProveedores : (state, action: PayloadAction<number>) => {
      const newArr = state.CatProveedores.filter(data => data.id != action.payload);
      state.CatProveedores=newArr
    },
  },
})

export const { resetCatProveedores, populateCatProveedores, updateCatProveedores, deleteCatProveedores } = CatProveedoresSlice.actions;
export default CatProveedoresSlice.reducer;